import { Input } from 'app/agriculture/forms/components/Input/Input';
import { Controller, useFormContext } from 'react-hook-form';
import './SensorCalibration.scss';
import classNames from 'classnames';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';

interface FormValues {
    tankMaxVolume: number | null;
    tankMaxHeight: number | null;
    tankCalibrationOffset: number | null;
}

interface SensorCalibrationProps {
    brand: 'Yarn' | 'Gasbot';
    small?: boolean;
}

export function SensorCalibration({ brand, small = false }: SensorCalibrationProps) {
    const form = useFormContext<FormValues>();

    return (
        <div className={classNames('SensorCalibration')}>
            <div className="SensorCalibration__Title">
                <h5>Sensor Calibration</h5>
            </div>
            <SimpleGrid columns={2} gap={small ? 32 : 72}>
                <div className="SensorCalibration__form">
                    <Controller
                        control={form.control}
                        render={({ field, formState }) => (
                            <Input
                                label="Fillable Volume"
                                type="number"
                                step={1000}
                                adornment={{ position: 'end', text: 'litres' }}
                                {...field}
                                value={field.value ?? undefined}
                                errorMessage={formState.errors.tankMaxVolume?.message}
                            />
                        )}
                        name="tankMaxVolume"
                        rules={{
                            required: 'Volume is required',
                            min: { value: 0, message: 'Volume must be a positive number' },
                        }}
                    />
                    {brand === 'Yarn' ? (
                        <Controller
                            control={form.control}
                            render={({ field, formState }) => (
                                <Input
                                    label="Calibration Distance"
                                    type="number"
                                    step={0.1}
                                    adornment={{ position: 'end', text: 'metres' }}
                                    {...field}
                                    value={field.value ?? undefined}
                                    errorMessage={formState.errors.tankCalibrationOffset?.message}
                                />
                            )}
                            name="tankCalibrationOffset"
                            rules={{
                                required: 'Calibration distance is required',
                            }}
                        />
                    ) : null}
                    <Controller
                        control={form.control}
                        render={({ field, formState }) => (
                            <Input
                                label="Fillable Height"
                                type="number"
                                step={0.1}
                                adornment={{ position: 'end', text: 'metres' }}
                                {...field}
                                value={field.value ?? undefined}
                                errorMessage={formState.errors.tankMaxHeight?.message}
                            />
                        )}
                        name="tankMaxHeight"
                        rules={{
                            required: 'Height is required',
                            min: { value: 0, message: 'Height must be a positive number' },
                        }}
                    />
                </div>
                <div className="SensorCalibration__image">
                    {brand === 'Yarn' ? (
                        <img
                            src={'assets/images/ultrasonic-sensor.png'}
                            alt="Sensor calibration diagram"
                        />
                    ) : (
                        <img
                            src={'assets/images/pressure-sensor.png'}
                            alt="Sensor calibration diagram"
                        />
                    )}
                </div>
            </SimpleGrid>
        </div>
    );
}
